<script setup lang="ts">
const props = defineProps<{
  html: string;
}>();

const proseRef = ref<HTMLElement | null>(null);

useDocsMermaid(proseRef, () => props.html);
</script>

<template>
  <div
    ref="proseRef"
    class="docs-prose"
    v-html="html"
  />
</template>
